import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind class names, letting a later class win over an earlier one that targets the
 * same property (`cn('p-2', 'p-4')` is `p-4`). Every component in this package uses it so
 * callers can override styling without fighting specificity.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
